// @flow
import React from 'react';

type PropsType = {
  className: string,
};

const SadFaceSvg = ({ className }: PropsType) => {
  return (
    <div className={className}>
      <svg width="" height="103" viewBox="0 0 297 103" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M123.279 45.2084L139.946 37.2917C141.278 36.6596 142.154 35.4002 142.244 33.988C142.334 32.5758 141.624 31.2254 140.382 30.4453C139.139 29.6653 137.553 29.5741 136.221 30.2063L119.554 38.123C117.847 38.9536 116.957 40.784 117.399 42.5571C117.84 44.3302 119.499 45.588 121.417 45.6042C122.062 45.6126 122.699 45.477 123.279 45.2084Z"
          fill="black"
        />
        <path
          d="M177.446 38.1031L160.779 30.1864C159.447 29.5543 157.861 29.6454 156.618 30.4255C155.376 31.2055 154.666 32.556 154.756 33.9682C154.846 35.3804 155.722 36.6397 157.054 37.2719L173.721 45.1886C174.298 45.464 174.937 45.6064 175.583 45.6042C177.518 45.6077 179.201 44.3454 179.646 42.5565C180.091 40.7677 179.182 38.9231 177.45 38.1031H177.446Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.5 55.5001C98.5 29.2665 120.886 8 148.5 8C176.102 8.02836 198.47 29.2783 198.5 55.5001C198.5 81.7336 176.114 103 148.5 103C120.886 103 98.5 81.7336 98.5 55.5001ZM106.833 55.5001C106.833 77.3614 125.488 95.0834 148.5 95.0834C171.501 95.0594 190.141 77.3514 190.167 55.5001C190.167 33.6388 171.512 15.9167 148.5 15.9167C125.488 15.9167 106.833 33.6388 106.833 55.5001Z"
          fill="black"
        />
        <path
          d="M141.9 54.5342C142.737 52.5488 141.762 50.2907 139.699 49.4348C137.636 48.5789 135.23 49.4347 134.266 51.3676C133.666 52.6832 132.301 53.5345 130.791 53.5345C129.282 53.5345 127.917 52.6832 127.316 51.3676C126.352 49.4347 123.947 48.5789 121.883 49.4348C119.82 50.2907 118.846 52.5488 119.683 54.5342C121.614 58.7268 125.974 61.4359 130.791 61.4359C135.608 61.4359 139.969 58.7268 141.9 54.5342Z"
          fill="black"
        />
        <path
          d="M173.083 49.3171C170.976 48.4433 168.523 49.3555 167.6 51.3557C166.999 52.6713 165.634 53.5226 164.125 53.5226C162.615 53.5226 161.25 52.6713 160.65 51.3557C159.686 49.4229 157.28 48.567 155.217 49.4229C153.154 50.2788 152.179 52.5369 153.016 54.5224C154.947 58.715 159.307 61.424 164.125 61.424C168.942 61.424 173.302 58.715 175.233 54.5224C176.15 52.5209 175.188 50.1924 173.083 49.3171Z"
          fill="black"
        />
        <path
          d="M148.5 67.3751C140.665 67.4081 133.292 70.898 128.546 76.8197C127.194 78.5468 127.543 80.9835 129.331 82.3053C131.118 83.6271 133.69 83.3496 135.121 81.6805C138.265 77.6593 143.227 75.2888 148.5 75.2888C153.773 75.2888 158.735 77.6593 161.879 81.6805C163.309 83.3496 165.881 83.6271 167.669 82.3053C169.457 80.9835 169.806 78.5468 168.454 76.8197C163.708 70.898 156.334 67.4081 148.5 67.3751Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default React.memo(SadFaceSvg);
